import { faCloud } from '@fortawesome/pro-regular-svg-icons'
import {
  faBrowser,
  faGrid,
  faLaptopMobile,
  faLayerGroup,
  faUser,
  faUsers
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useDashboardDataProvider } from 'features/dashboard'
import { IAMResourcesSliceNames } from 'features/iamResources'
import { TargetsSliceNames } from 'features/targets'
import { MapSliceNameToKind } from 'infra/redux'
import { CloudIcon, CountersCard } from 'procyon-ui'
import React, { useEffect } from 'react'
import useMultiSlice from 'Core/Hooks/useMultiSlice'

const CountCards = () => {
  const { slices, selectDispatch } = useMultiSlice([
    'deviceList',
    'userList',
    'groupList',
    'applicationList',
    'accountList'
  ])

  useEffect(() => {
    selectDispatch(['deviceList', 'userList', 'groupList', 'applicationList', 'accountList'])
  }, [])

  const getCounts = () => {
    const counts = {
      gcp: 0,
      aws: 0,
      azure: 0,
      targets: 0,
      resources: 0,
      devices: slices.deviceList.length,
      users: slices.userList.length,
      groups: slices.groupList.length,
      applications: slices.applicationList.length
    }

    slices.accountList.forEach((acc) => {
      const type = acc.Spec.Type.toLowerCase()
      const countsMap = acc.Status.ResourcesInfo.Map

      const targetsCount = TargetsSliceNames.reduce((prev, sname) => {
        const kind = MapSliceNameToKind[sname]
        return prev + (+countsMap[kind] || 0)
      }, 0)

      const resourcesCount = IAMResourcesSliceNames.reduce((prev, sname) => {
        const kind = MapSliceNameToKind[sname]
        return prev + (+countsMap[kind] || 0)
      }, 0)

      counts.targets += targetsCount
      counts.resources += resourcesCount

      counts[type] = counts[type] + 1
    })

    return counts
  }

  const counts = getCounts()

  const getCountData = () => {
    const countElements = [
      {
        title: 'Accounts',
        icon: <FontAwesomeIcon color='var(--color-font-base)' icon={faCloud} />,
        items: [
          {
            count: counts.aws,
            element: <CloudIcon type='aws' />
          },
          {
            count: counts.gcp,
            element: <CloudIcon type='gcp' />
          },
          {
            count: counts.azure,
            element: <CloudIcon type='azure' />
          }
        ]
      },
      {
        title: 'Identity & Devices',
        icon: <FontAwesomeIcon color='var(--color-font-base)' icon={faUsers} />,
        items: [
          {
            count: counts.users,
            element: <FontAwesomeIcon color='var(--color-font-base)' icon={faUser} />
          },
          {
            count: counts.groups,
            element: <FontAwesomeIcon color='var(--color-font-base)' icon={faUsers} />
          },
          {
            count: counts.devices,
            element: <FontAwesomeIcon color='var(--color-font-base)' icon={faLaptopMobile} />
          }
        ]
      },
      {
        title: 'Resources',
        icon: <FontAwesomeIcon color='var(--color-font-base)' icon={faBrowser} />,
        items: [
          {
            count: counts.targets,
            element: <FontAwesomeIcon color='var(--color-font-base)' icon={faLayerGroup} />
          },
          {
            count: counts.resources,
            element: <FontAwesomeIcon color='var(--color-font-base)' icon={faBrowser} />
          },
          {
            count: counts.applications,
            element: <FontAwesomeIcon color='var(--color-font-base)' icon={faGrid} />
          }
        ]
      }
    ]

    return countElements
  }

  const countsElements = getCountData()

  return (
    <div className='flex gap-8 mb-6'>
      {countsElements.map((e, i) => {
        return (
          <CountersCard
            key={i}
            style={{ width: '33%' }}
            className='!w-1/3 !font-bold'
            counterItems={e.items}
            icon={e.icon}
            onClick={function noRefCheck() {}}
            title={e.title}
            type='simple'
          />
        )
      })}
    </div>
  )
}

export { CountCards }
